import { useReducer } from 'react';

export function useForceUpdate() {
  const [count, forceUpdate] = useReducer((count: number) => count + 1, 0);

  return { count, forceUpdate };
}
